export default __webpack_public_path__ + "static/LandAcquisitionAndConservationEasements-f37dc45176dfc4bfb2d1a1378c901981.jpg";